<div innerHTML="{{'add-child-unit-button.demo-privacy-policy' | translate}}"></div>
